<script>
export default {
    name: 'IconCard',
}
</script>
<template>
    <svg class="base-icon icon-card" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64"><path fill="currentColor"  fill-rule="evenodd" d="M3.2 3h57.6c.849 0 1.663.34 2.263.944.6.604.937 1.424.937 2.278v51.556c0 .854-.337 1.674-.937 2.278-.6.605-1.414.944-2.263.944H3.2c-.849 0-1.663-.34-2.263-.944A3.233 3.233 0 0 1 0 57.778V6.222c0-.854.337-1.674.937-2.278A3.188 3.188 0 0 1 3.2 3Zm54.4 25.778H6.4v25.778h51.2V28.778Zm0-6.445V9.444H6.4v12.89h51.2ZM38.4 41.667h12.8v6.444H38.4v-6.444Z" clip-rule="evenodd"/></svg>
</template>